import React from "react";
import { useLocation } from "react-router-dom";
import ScheduleList from "./ScheduleList";
import CheckSuppressions from "./CheckSuppressions";

const SCHEDULE_PATH = /^\/configuration\/cspm\/schedules\/([^/]+)\/?$/;

const CspmConfiguration = () => {
  const location = useLocation();
  const match = location.pathname.match(SCHEDULE_PATH);
  const scheduleId = match ? decodeURIComponent(match[1]) : "";

  if (scheduleId) {
    return <CheckSuppressions key={scheduleId} scheduleId={scheduleId} />;
  }

  return <ScheduleList />;
};

export default CspmConfiguration;
